exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-btn[data-v-bb979792] {\n    margin: 0 0 6px;\n}\n.v-btn--large[data-v-bb979792] {\n    height: 48px;\n}\n", ""]);

// exports
